import React, { useEffect, useState } from 'react';

// bootstrap
import Image from 'react-bootstrap/Image';

// redux
import { useSelector } from 'react-redux';
import { selectReceipientsInformation } from '_redux/slices/messaging/messaging'

// placeholder
import placeholder from "_assets/images/profile/placeholder.jpeg";

// styling
import { Spacing } from '_styles';

const MessengerProfilePicture = (props) => {

    const userList = useSelector(selectReceipientsInformation)
    const [imageSrc, setImageSrc] = useState(placeholder);

    useEffect(() => {
        //Check if user has photo url, if not add placeholder image
        if (userList && props.user && userList[props.user] && userList[props.user].photoURL) {
            //if url includes 123, we need to replace it with userid,this is from application check action in app:dispatch(uploadProfileImage({'displayName':'123', 'path': imagePath})) 
            if (userList[props.user].photoURL?.includes("o/123?")) {
                const photoURL = userList[props.user].photoURL.replace("o/123?", `o/${props.user}?`);
                setImageSrc(photoURL)
            } else {
                setImageSrc(userList[props.user].photoURL,)
            }
        } else {
            setImageSrc(placeholder)
        }
    }, [props.user, userList])

    return (
        <>
            {props.user ?
                <Image
                    src={imageSrc}
                    height={props.small ? 35 : 50}
                    width={props.small ? 35 : 50}
                    style={{
                        borderRadius: 50,
                        marginTop: Spacing.SCALE_12,
                        marginBottom: Spacing.SCALE_12,
                        objectFit: 'cover', // Add this line
                    }}
                />
                : ""
            }
        </>
    )
};

export default MessengerProfilePicture;
